import { LoadableRoute } from 'routes/utils/loadable';

export const CompanyProfileContainer = LoadableRoute({
  loader: () =>
    import(/* webpackChunkName: "CompanyProfile" */ './CompanyProfile'),
});
